import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  ControlLabel,
  DropdownButton,
  Form,
  FormGroup,
  InputGroup,
  Label,
  MenuItem,
} from 'react-bootstrap';

import _ from 'lodash';

import { Form as FinalForm } from 'react-final-form';
import { Field } from 'react-final-form-html5-validation';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import AttributeSelector from '../../components/Integrations/NetDocuments/AttributeSelector';

class NetDocumentsCabinetProfileConfigAttributeForm extends Component {

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    cabinet: PropTypes.object.isRequired,
    attributes: PropTypes.array.isRequired,
    onSave: PropTypes.func.isRequired,
    cabinetAttributes: PropTypes.array.isRequired,
  };

  render() {
    return (
      <FinalForm
        initialValues={ { attributes: this.props.attributes } }
        onSubmit={ this.props.onSave }
        mutators={{
          ...arrayMutators
        }}
        render={({
          handleSubmit,
          pristine,
          form,
          submitting,
          reset,
          values,
          submitError,
          hasValidationErrors,
        }) => {
          return (
            <Form horizontal style={{ padding: "8px 42px 8px 16px", }} onSubmit={handleSubmit}>
              <FieldArray name="attributes">
                { ({fields}) => fields.map(
                    (name, index) => renderAttributeEditInput(form, values, this.props.attributes, name, index, this.props.cabinet, this.props.connectionId, this.props.cabinetAttributes)
                ) }
              </FieldArray>

              {submitError && <Alert bsStyle="danger">{submitError}</Alert>}
              <FormGroup>
                <Button type="submit" bsStyle="primary"
                        title={hasValidationErrors ? "Can't save while form contains invalid values" : undefined}
                        disabled={submitting || pristine || hasValidationErrors}>
                  <i className={`fa ${ submitting ? 'fa-spinner fa-spin' : 'fa-gavel' }`} />
                  { ' ' } Save
                </Button>

                <Button
                  bsStyle="link"
                  onClick={ () => { if(  pristine || confirm("You will lose unsaved changes") ) reset(); return false; } }
                  disabled={submitting || pristine}>
                  Reset
                </Button>

              </FormGroup>

              {hasValidationErrors &&
              <Alert bsStyle="danger">Please correct any errors above before saving.</Alert>
              }

            </Form>
          )
        }} />
    );
  }
}

// Net Document Profile Field types: https://support.netdocuments.com/hc/en-us/articles/205220550

function renderAttributeEditInput( form, values, attributes, name, index, cabinet, connectionId, cabinetAttributes) {
  const parentAttribute = attributes[index].linked && _.find(cabinetAttributes, { id: attributes[index].linked });
  const isRequired = cabinet.wsOrgAttrNum == attributes[index].id;
  const hasError = _.get(form.getState(), `errors.attributes[${index}]`);

  return (
    <FormGroup validationState={ hasError && 'error' }>
      <ControlLabel>
        {attributes[index].name}
        <sup> <Label>Type: {attributes[index].type}</Label></sup>
        <sup> <Label>Max Len: {attributes[index].maxLen}</Label></sup>
        {attributes[index].useLookup && <sup> <Label><i className="fa fa-binoculars" /> Lookup</Label></sup>}
        {attributes[index].linked && <sup> <Label title="This attribute values are dependant on values selected in another attribute"><i className="fa fa-link" /> Linked</Label></sup>}
        {isRequired && <sup> <Label bsStyle={hasError ? 'danger' : 'success'}>Required</Label></sup>}
      </ControlLabel>
      {attributes[index].useLookup && !attributes[index].linked ?
        <Field name={`${name}.value`} validate={ (val) => isRequired && ! val ? 'Required' : undefined }>
          {({ input }) => (
            <Fragment>
            <AttributeSelector
              attribute={attributes[index]}
              connectionId={connectionId}
              cabinet={cabinet}
              initialValue={values.attributes[index].value}
              input={input}
              showPerCaseOption={isRequired}
            />
            </Fragment>
          )}
        </Field>

        :
        attributes[index].linked ?
          <Alert bsStyle="warning">
            Configuring this attribute is not currently supported as it depends on <strong>{_.get(parentAttribute, 'name', `Attribute <ID:${attributes[index].linked}>`)}</strong> selection.
          </Alert>
        :
        <InputGroup>
          <Field name={`${name}.value`} component="input" type="input" className="form-control"
                 required={isRequired}
          />

          <TemplateMenu
            onSelect={ templateVal => form.change(`${name}.value`, (values.attributes[index].value || '') + templateVal ) }
            />
        </InputGroup>
      }
    </FormGroup>
  );
}

function TemplateMenu( props ) {
  const fieldsToOffer = netdocs_fields;


  let previousFieldType = fieldsToOffer[0].type; // remember so we can draw divider in the menu

  return (
    <DropdownButton
      componentClass={InputGroup.Button}
      bsStyle="default"
      title="+"
      noCaret
    >
      {
        fieldsToOffer.map( field => [
          previousFieldType !== field.type && (previousFieldType = field.type) && <MenuItem divider />, // <MenuItem header>{ field.type }</MenuItem>,
          <MenuItem onSelect={ () => props.onSelect(fieldToInput(field)) } style={{ width: '316px' }}>
            {field.value}
            <small style={{ float: 'right' }}><Label>{fieldToInput(field)}</Label></small>
            <div style={{ clear: 'both' }} />
          </MenuItem>,
        ])
      }
    </DropdownButton>
  );
}

function fieldToInput(field) {
  return field.type === 'separator'
    ? field.name
    : `{{${field.name}}}`;
}

const netdocs_fields = [
  {
    type: 'document',
    name: 'document_date',
    value: 'Document Filed Date',
  },
  {
    type: 'document',
    name: 'part_description',
    value: 'Part Description',
  },
  {
    type: 'document',
    name: 'docket_number',
    value: 'Document Entry Number',
  },
  {
    type: 'document',
    name: 'docket_text',
    value: 'Docket Text',
  },
  {
    type: 'case',
    name: 'case_title',
    value: 'Case Title',
  },
  {
    type: 'case',
    name: 'case_date',
    value: 'Case Date',
  },
  {
    type: 'case',
    name: 'case_number',
    value: 'Case Number',
  },

  {
    type: 'court',
    name: 'court_code',
    value: 'Court Code',
  },
  {
    type: 'court',
    name: 'court_name',
    value: 'Court Name',
  },
  {
    type: 'court',
    name: 'court_citation',
    value: 'Court Citation',
  },
  {
    type: 'judge',
    name: 'judge_name',
    value: 'Judge Name',
  },
  {
    type: 'separator',
    name: '-',
    value: '-',
  },
  {
    type: 'separator',
    name: '(',
    value: '(',
  },
  {
    type: 'separator',
    name: ')',
    value: ')',
  },
  {
    type: 'separator',
    name: '.',
    value: '.',
  },
  {
    type: 'separator',
    name: '/',
    value: '/',
  },
  {
    type: 'separator',
    name: '_',
    value: '_',
  },
  {
    type: 'separator',
    name: ' ',
    value: '[space]',
  },
];


export default NetDocumentsCabinetProfileConfigAttributeForm;



// WEBPACK FOOTER //
// ./src/Integrations/connections/NetDocumentsCabinetProfileConfigAttributeForm.jsx